/* eslint-disable no-restricted-imports */
import router from 'next/router';

export const updatePromoCodeQuery = (redirectBaseUrl: string) => {
	router.push(redirectBaseUrl, undefined, { shallow: true });
};
